import { PaginationData, PaginationPcApiResponse } from '@/api/pc-api/types';
import { ContractStatus } from '@/constants/contract';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type DealerContract = {
  autoRenewal: boolean;
  finishedAt: string;
  id: string;
  renewalPeriod: number | null;
  startedAt: string;
  status: ContractStatus;
};

export type DealerContractList = DealerContract[];
export type DealerContractListPagination = PaginationData<DealerContractList>;

const DEFAULT_PAGE_SIZE = 10;

export const getDealerContractList = (dealerId: string, page: number, size = DEFAULT_PAGE_SIZE) => {
  return api<PaginationPcApiResponse<DealerContractList>>('get', `/pc-api/v1/${PREFIX_PATH}/contract/list/dealer`, {
    dealerId,
    page,
    size
  });
};
